import React from 'react'
import { Navbar, Footer, Newsbar } from '../../components';
import { SolarInputs } from "."

export default function About() {
  return (
    <div className='emas__about'>
      <Navbar />
      <SolarInputs />
      <Footer />
    </div>
  )
}
